<template>
    <div class="feedback-buttons-row">
        <div class="buttons">
            <div class="flex-1">
                <action-group
                    @request="requestFeedback()"
                    @send="sendFeedback()"
                />
            </div>
            <div
                class="flex-1 d-flex justify-content-end template-button"
                v-if="canViewTemplates"
            >
                <b-button variant="outline-primary" @click="goToTemplatesPage">
                    {{ $t('talk.feedbackTemplate') }}
                </b-button>
            </div>
        </div>
        <tabs
            :tabs="availableTabs"
            @tabChange="setActiveTab"
            class="tabs-container flex-2"
            :badgeCount="pendingCount"
            :loading="loading"
            module="feedbacks"
        />
    </div>
</template>

<script>
import data from './data'

import { ActionGroup } from '../'
import Tabs from '@/views/components/tabs'
import availableTabsMixin from '../../availableTabsMixin'
import { EventBuzz } from '@/main'

export default {
    name: 'FeedbacksHeader',
    components: {
        ActionGroup,
        Tabs,
    },
    mixins: [availableTabsMixin],
    props: {
        pendingCount: Number,
        loading: Boolean,
        roleTab: {
            default: 'user',
            type: String,
        },
    },
    data() {
        const dataParsed = data()
        return {
            ...dataParsed,
            availableTabs: [],
            roleSelected: 'user',
        }
    },
    mounted() {
        this.parseAvailableTabs().then(() => {
            this.getActiveTab()
        })
        EventBuzz.$on('roleChanged', role => {
            this.roleSelected = role
            this.availableTabs = []
            this.parseAvailableTabs().then(() => {
                this.getActiveTab()
            })
        })
    },
    methods: {
        getActiveTab() {
            if (this.roleSelected === 'administrator') {
                this.setActiveTabInArray('sent')
            } else {
                this.setActiveTabInArray('received')
            }

            const id = this.tabs.find(t => t.active).id
            this.setActiveTab(id)
        },
        setActiveTab(id) {
            this.activeTab = id
            this.$emit('tabChanged', id)
        },
        requestFeedback() {
            if (this.roleTab !== 'administrator') {
                return this.pushDefaultRequestModal()
            }
            this.pushAdminRequestModal()
        },
        sendFeedback() {
            this.$router.push({
                path: `/v2/feedbacks/list/send`,
            })
        },
        pushDefaultRequestModal() {
            this.$router.push({
                path: `/v2/feedbacks/list/request`,
            })
        },
        pushAdminRequestModal() {
            this.$router.push({
                path: '/v2/feedbacks/list/requestAdmin',
            })
        },
        goToTemplatesPage() {
            this.$router.push({
                path: `/v2/feedbacks/templates`,
            })
        },
        canViewTab(tab) {
            if (tab === 'received') {
                return this.roleSelected !== 'administrator'
            }

            return true
        },
        setActiveTabInArray(tab) {
            this.tabs.forEach(element => {
                if (element.id === tab) {
                    element.active = true
                }
            })
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        canViewTemplates() {
            const { is_values_master, role } = this.currentUser
            const isAdmin = role.name === 'administrator'
            const isGod = role.name === 'god'
            const isLocalAdmin = role.name === 'local_administrator'

            return is_values_master || isAdmin || isGod || isLocalAdmin
        },
    },
}
</script>

<style lang="sass" scoped>
.feedback-buttons-row
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    background-color: #fff
    .buttons
        display: flex
        justify-content: center
        flex-direction: column
        align-items: flex-start
        .flex-1
            margin: 10px 0
            width: 100%
        .template-button
            button
                width: 100%

@media (min-width: 600px)
    .feedback-buttons-row
        .buttons
            flex-direction: row

@media (min-width: 1200px)
    .feedback-buttons-row
        flex-direction: row
        position: relative
        .buttons
            position: absolute
            width: 100%
            justify-content: space-between
            .flex-1
                margin: 0
            .template-button
                button
                    width: auto
</style>
